'use strict'

import fetch from '../../../libs/@elements/fetch';
import { getLoadingContainer, removeLoadingContainer } from "../../../scripts/loading";
import { showNotification } from '../../../libs/@elements/alert-notification';

export function initInScope($scope) {
    const $requestBtn = $scope.find('.js-strex-request_cart');
    const $modal = $scope.find('.modal--add_to_cart');
    const $successModal = $scope.find('.modal--request-success');

    let pendingRequest;

    $requestBtn.on('click', () => {
        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }

        // Get the request URL from the button's data attribute
        const url = $requestBtn.data('href') || `${globalThis.location.href}/request-basket`;

        // Add loading spinner
        $(getLoadingContainer()).appendTo($requestBtn);
        $requestBtn.prop('disabled', true);

        pendingRequest = fetch(url, {
            method: 'post'
        });

        $modal.modal('hide');
        pendingRequest
            .then(response => {
                if (response.success) {
                    // Hide the cart modal and show success modal
                    $successModal.modal('show');
                }
                showNotification(pendingRequest);
            })
            .catch(error => {
                console.error('Error requesting cart:', error);
                showNotification(pendingRequest);
            })
            .finally(() => {
                removeLoadingContainer($requestBtn);
                $requestBtn.prop('disabled', false);
                pendingRequest = null;
            });
    });
} 